import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useInView } from 'react-intersection-observer';
import { Slider } from 'antd';
import { debounce } from 'lodash-es';

import styles from './SliderTag.module.less';
import { logging, logPostInfo } from '../../../actions/log';
import { changeClass } from '../../../utils/utils';
import { set } from 'lodash-es';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ param }) => {
  const {
    min,
    max,
    defaultValue = 100,
    defaultTip,
    formatterTip = () => {},
    onTagChange = () => {},
  } = param;
  const dispatch = useDispatch();
  const history = useHistory();

  const [value, setValue] = useState(defaultValue);
  const [tip, setTip] = useState(defaultTip || '高');

  const [sliderDom, setSliderDom] = useState(null);
  const [sliderTipDom, setSliderTipDom] = useState(null);

  useEffect(() => {}, []);

  const onMouseOver = useCallback(
    e => {
      changeClass(sliderTipDom, styles.mouse_in, styles.mouse_out);
    },
    [sliderTipDom],
  );
  const onMouseLeave = useCallback(
    e => {
      changeClass(sliderTipDom, styles.mouse_out, styles.mouse_in);
    },
    [sliderTipDom],
  );
  const onChange = useCallback(value => {
    setValue(value);
    if (typeof formatterTip === 'function') {
      setTip(formatterTip(value));
    } else {
      setTip(value);
    }
    onTagChange(value);
  }, []);

  return (
    <div
      className={styles.slider_line}
      onMouseOver={e => onMouseOver(e)}
      onMouseLeave={e => onMouseLeave(e)}
      ref={r => setSliderDom(r)}
    >
      <Slider
        min={param?.min || 0}
        max={param?.max || 100}
        defaultValue={param?.defaultValue || 100}
        tooltip={{
          open: false,
        }}
        onChange={onChange}
      />
      <div
        className={`slider_line_tip ${styles.mouse_out}`}
        ref={r => setSliderTipDom(r)}
        style={{ left: `${value}%` }}
      >
        {tip || ''}
      </div>
    </div>
  );
});
